/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  dlsBrightBlue,
  IconList,
  Navigation,
  NavigationItem,
  Tooltip,
  TooltipButton,
} from '@americanexpress/dls-react';
import OverflowItem from '../../OverflowItem';
import { useEnhancedDataTableContext } from '../EnhancedDataTableContext';
import { getSelectedRows, isAnyRowSelect, resetTableSelections } from '../EnhanceDataTableUtil';
import itemActionListStyle from '../../../styles/EnhancedTableToolbar/ItemActionList';

const EnhancedTableToolbarItemActionList = React.memo((props) => {
  const context = useEnhancedDataTableContext();

  const {
    onItemActionClick,
    isItemActionClicked,
    setItemActionClicked,
  } = props;
  const [iconFilled, setIconFilled] = useState(false);

  const {
    tableNm,
    actionList,
    inlineItemAction = false,
  } = context;

  const [modifiedActionList, setModifiedActionList] = useState(_.cloneDeep(actionList));

  const onItemActionClickHandler = (actionId) => {
    const selectedRows = getSelectedRows(context);
    onItemActionClick(actionId, selectedRows);
    setItemActionClicked(false);
    resetTableSelections(context);
  };

  useEffect(() => {
    if (actionList?.length > 0) {
      if (getSelectedRows(context.tableData)?.length > 1) {
        setModifiedActionList(actionList?.filter((action) => action.id !== 'update'));
      } else {
        setModifiedActionList(_.cloneDeep(actionList));
      }
    }
    if (isAnyRowSelect(context)) {
      setItemActionClicked(true);
    } else {
      setItemActionClicked(false);
    }
  }, [context.tableData, actionList]);

  return (actionList?.length > 0 && modifiedActionList?.length > 0
      && onItemActionClick && isAnyRowSelect(context) && !inlineItemAction)
    && (
      <div
        id={`${tableNm}-table-action-component`}
        style={{
          display: 'inline-block',
          marginRight: '15px',
        }}
      >
        <OverflowItem
          labelComponent={(
            <Tooltip
              id={`${tableNm}-table-action-button-tooltip`}
              triggerElement={(
                <TooltipButton
                  icon={<IconList size="md" theme={dlsBrightBlue} title="Action List" filled={iconFilled} />}
                  id={`${tableNm}-table-action-button`}
                  onMouseOver={() => {
                    setIconFilled(true);
                  }}
                  onMouseOut={() => {
                    setIconFilled(false);
                  }}
                  onClick={() => setItemActionClicked(!isItemActionClicked)}
                />
              )}
              placement="top"
              forcePlacement={true}
            >Action(s)
            </Tooltip>
          )}
          width="180"
          isLabelComponentClicked={isItemActionClicked}
          id={`${tableNm}-item-action-overflowItem`}
          isOutsideClick={false}
        >
          <Navigation
            aria-label="Popup Action List"
            id={`${tableNm}-item-action-navigation`}
            css={itemActionListStyle['.navigation']}
          >
            {modifiedActionList.map((item) => (
              <NavigationItem
                key={`${tableNm}-item-action-${item.id}`}
                id={`${tableNm}-item-action-${item.id}`}
                label={item.label}
                href=""
                onClick={() => onItemActionClickHandler(item.id)}
                theme={item.theme ? item.theme : itemActionListStyle['.navigationItem']}
              />
            ))}
          </Navigation>
        </OverflowItem>
      </div>
    );
});

EnhancedTableToolbarItemActionList.displayName = 'EnhancedTableToolbarItemActionList';

EnhancedTableToolbarItemActionList.propTypes = {
  onItemActionClick: PropTypes.func.isRequired,
};

export default EnhancedTableToolbarItemActionList;
